/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  '@atlassian/edition-awareness.button.addPaymentDetails': '결제 세부 정보 추가',
  '@atlassian/edition-awareness.button.automation-limits-breached': '한도에 도달함',
  '@atlassian/edition-awareness.button.automation-near-limit': '한도에 가까움',
  '@atlassian/edition-awareness.button.daysLeft': '{trialDaysLeft, plural, other {{trialDaysLeft,number}일 남음}}',
  '@atlassian/edition-awareness.button.education-offer': '교육 기관 할인',
  '@atlassian/edition-awareness.button.limited-users-left':
    '{product, select, jpd {작성자가 얼마 남지 않음} jsm {에이전트가 얼마 남지 않음} jira {사용자가 얼마 남지 않음} confluence {사용자가 얼마 남지 않음} other {사용자가 얼마 남지 않음}}',
  '@atlassian/edition-awareness.button.limited-users-left-content-adjustment':
    '{product, select, jpd {1명의 작성자 남음} jsm {1명의 에이전트 남음} other {1명의 사용자 남음}}',
  '@atlassian/edition-awareness.button.no-users-left':
    '{product, select, jpd {남은 작성자 없음} jsm {남은 에이전트 없음} jira {남은 사용자 없음} confluence {남은 사용자 없음} other {남은 사용자 없음}}',
  '@atlassian/edition-awareness.button.no-users-left-content-adjustment':
    '{product, select, jpd {남은 작성자 없음} jsm {남은 에이전트 없음} other {남은 사용자 없음}}',
  '@atlassian/edition-awareness.button.premium-trial': 'Premium 평가판',
  '@atlassian/edition-awareness.button.see-plans': '플랜 보기',
  '@atlassian/edition-awareness.button.see-plans.cbrt': '플랜 보기',
  '@atlassian/edition-awareness.button.standard-trial': 'Standard 평가판',
  '@atlassian/edition-awareness.button.storage-hard-limit': '저장 공간 가득 참',
  '@atlassian/edition-awareness.button.upgrade': '업그레이드',
  '@atlassian/edition-awareness.button.upgrade.standard-to-premium': '업그레이드',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.approaching-limits.subtitle':
    '{automation_limit_runs_free, plural, other {자동화는 매월 {automation_limit_runs_free}번 실행 후 중단합니다}}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.approaching-limits.title':
    '{automation_limit_runs_free, plural, other {{automation_limit_runs_free}번의 자동화 실행 중 {automations_used}번 실행했습니다}}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.automations-breached-title':
    '자동화 실행 횟수가 끝났습니다. 계속 실행하려면 업그레이드하세요',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.breached-limits.breached-subtitle':
    '자동화는 다음 달에 다시 실행할 수 있습니다',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.breached-limits.title': '제한에 도달했습니다!',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.dismiss': '해제',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.free-limit': 'Free 한도',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.free-limit-value':
    '{automation_limit_runs_free, plural, other {{automation_limit_runs_free,number}번 실행}}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.standard-features.automation-benefits':
    '반복 작업을 자동화하여 시간을 절약하세요',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.standard-features.more-automations':
    'Standard로 {automation_runs_standard_comparison}배 더 실행하세요',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.standard-features.unlimited-users':
    '무제한 사용자, 추가 보안 등을 활용하세요',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.standard-limit': 'Standard 한도',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.standard-limit-value':
    '{automation_limit_runs_standard, plural, other {{automation_limit_runs_standard,number}번 실행}}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.text.automation-limits-reset':
    '매달 실행이 초기화됩니다.',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.text.automation-limits-reset-with-manage-automations':
    '매달 실행이 초기화됩니다. <Link>자동화 관리</Link>',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.title':
    '중단 없이 자동화를 계속 실행하려면 업그레이드하세요',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.upgrade': '업그레이드',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.add-payment-details': '결제 세부 정보 추가',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.dismiss': '해제',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.free-limit': 'Free 한도',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.free-limit-value':
    '{automation_limit_runs_free, plural, other {{automation_limit_runs_free,number}번 실행}}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.modal-title':
    '자동화를 계속 실행하려면 결제를 추가하세요',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.standard-features.automation-benefits':
    '고급 관리자 컨트롤 및 권한',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.standard-features.more-automations':
    '{automation_limit_standard_comparison, plural, other {매월 {automation_limit_standard_comparison}배 더 많이 자동화 실행}}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.standard-features.unlimited-users':
    '무제한 사용자 유지, 보안 강화 등',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.standard-limit': 'Standard 한도',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.standard-limit-value':
    '{automation_limit_runs_standard, plural, other {{automation_limit_runs_standard,number}번 실행}}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.text.automation-limits-add-payment':
    'Free 플랜은 자동화 실행 횟수가 적습니다. 평가판이 종료될 때({endDate,date,medium})까지는 요금이 청구되지 않습니다.',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.text.automation-limits-add-payment-without-date':
    'Free 플랜은 자동화 실행 횟수가 적습니다. 평가판이 종료될 때까지는 요금이 청구되지 않습니다.',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.text.automation-limits-list-features':
    'Standard로 업그레이드하여 이 기능을 그대로 사용하세요.',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.title':
    'Free 플랜은 실행 횟수가 {automation_free_limit_percentage_comparison,number,::percent}회 더 적습니다',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.title-not-breached':
    '다운그레이드하면 실행 횟수가 {automation_free_limit_percentage_comparison,number,::percent}회 더 줄어듭니다',
  '@atlassian/edition-awareness.dialog.automation-limits-modal.approaching-limits.projection-title':
    '매월 {projection}번 자동화를 실행할 것으로 예상됩니다',
  '@atlassian/edition-awareness.dialog.automation-limits-modal.approaching-limits.title':
    '규모에 맞게 자동화를 계속 사용하려면 업그레이드 상태를 유지하세요',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.apply-description':
    '지금 바로 신청하세요. 승인되면 선택한 플랜에 할인이 자동으로 적용됩니다. 다음의 기능을 이용하세요.',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.apply-for-discount': '할인 신청',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.compare-plans': '플랜 비교',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.dont-show-again': '이 메시지를 다시 표시하지 않음',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.confluence.hub':
    '뉴스, 업데이트 및 리소스를 확인할 수 있는 중앙 허브',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.confluence.users':
    '무제한 사용자로 쉽게 공동 작업자 추가',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.confluence.whiteboards':
    '그룹 아이데이션을 위한 무제한 화이트보드',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jira.grammar': '문법 및 글쓰기 어시스턴트',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jira.security':
    '고급 보안 및 사용에 대한 인사이트',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jira.users':
    '무제한 사용자로 쉽게 공동 작업자 추가',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jpd.security':
    '고급 보안 및 사용에 대한 인사이트',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jpd.users':
    '무제한 사용자로 쉽게 공동 작업자 추가',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jpd.views':
    '향후 계획을 공유하는 읽기 전용 보기',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jsm.agents':
    '일상적인 요청을 처리하는 자동화된 서비스 에이전트',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jsm.security':
    '고급 보안 및 사용에 대한 인사이트',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jsm.users':
    '최대 20,000명의 지원 센터 에이전트 및 무제한 고객',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.illustration.alt':
    '교사, 학생 등: 최대 75% 할인을 신청하세요.',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.title': '교육 기관 할인을 받으세요 📚',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.heading-at-limit':
    'Free 사용자를 모두 사용했습니다',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.heading-get-everyone-in-one-tool':
    '모두가 하나의 도구를 사용하도록 하세요',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.heading-near-limit':
    '팀 인원을 추가하려면 업그레이드하세요',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.invited-users-count':
    '{numberOfUsers}/{licensedUserLimit}명 초대됨',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.maybe-later': '나중에',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.subtitle-for-premium':
    '30일 무료 Premium 평가판을 시작하세요. 언제든지 취소할 수 있으며 평가판이 종료되기 3일 전에 알려드리겠습니다.',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.subtitle-for-standard':
    '14일 무료 Standard 평가판을 시작하세요. 언제든지 취소할 수 있으며 평가판이 종료되기 3일 전에 알려드리겠습니다.',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.try-it-now': '지금 사용해 보기',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.upgrade-for-gb-storage':
    '{gbToBuy}GB 스토리지로 업그레이드',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.upgrade-for-unlimited-storage':
    '무제한 스토리지를 이용하려면 업그레이드하세요',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.upgrade-for-unlimited-users':
    '무제한 사용자를 이용하려면 업그레이드하세요',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.user-limit-description-for-premium':
    '{licensedUserLimit, plural, other {{licensedUserLimit}명이 넘는 사용자를 추가하면 자동으로 업그레이드됩니다}}',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.user-limit-description-for-standard':
    '{licensedUserLimit, plural, other {사용자를 {licensedUserLimit}명 넘게 초대하면 14일 무료 Standard 평가판이 시작됩니다}}',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.continue': '나중에',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.heading': '무제한 사용자를 위해 업그레이드',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.heading-at-limit':
    '한도에 도달했습니다. 업그레이드해야 합니다',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.heading-near-limit':
    '전체 팀을 추가하려면 업그레이드하세요',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.standard-features.atlassian-support':
    'Atlassian의 지원',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.standard-features.data-security':
    'Free 플랜보다 강력한 데이터 보안',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.standard-features.more-automations':
    '더 많은 자동화 및 저장 공간',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.standard-features.start-trial-description':
    '14일 무료 Standard 평가판을 시작하여 고급 기능을 이용하세요. 언제든지 취소할 수 있습니다. 다음을 이용할 수 있습니다.',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.standard-features.unlimited-users': '무제한 사용자',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.upgrade': '업그레이드',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.user-limits.leftover-users-title':
    '{leftoverUsers, plural, other {{leftoverUsers}명의 무료 사용자가 남음}}',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.user-limits.no-users-title': '남은 무료 사용자가 없음',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.user-limits.user-limits-auto-trial-description':
    '10명이 넘는 사용자를 초대하면 자동으로 평가판이 시작됩니다',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.user-limits.user-limits-free-limit-description':
    'Free 플랜 한도는 사용자 10명입니다',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.user-limits.user-limits-title':
    '{licensedUserLimit, plural, other {{licensedUserLimit}/{numberOfUsers}명의 무료 사용자를 추가함}}',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.storage-limits.description':
    '{standardStorageLimit}GB 스토리지로 업그레이드',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.storage-limits.title':
    '{storageUsed}/{storageLimit}GB 사용',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.storage-limits.title.aria':
    '{storageUsed}/{storageLimit}GB의 스토리지를 사용했습니다',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.storage-used.title':
    '{storageUsed}/{storageLimit}GB 사용',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.storage-used.title.aria':
    '{storageUsed}/{storageLimit}GB 사용',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.user-limits.description':
    '무제한 사용자를 위해 업그레이드',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.user-limits.description.near-limit':
    '{licensedUserLimit, plural, other {사용자를 {licensedUserLimit}명 넘게 초대하면 14일 무료 Standard 평가판이 시작됩니다}}',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.user-limits.title':
    '{numberOfUsers}/{licensedUserLimit}명 초대됨',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.description':
    '14일 무료 Standard 평가판을 시작하세요. 언제든지 취소할 수 있으며 평가판이 종료되기 3일 전에 알려드리겠습니다.',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.maybe-later': '나중에',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.title-at-limit': 'Free 사용자를 모두 사용했습니다',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.title-near-limit':
    '팀 인원을 추가하려면 업그레이드하세요',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.title-not-near-limit':
    '모두가 하나의 도구를 사용하도록 하세요',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.try-now': '지금 사용해 보기',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.increased-storage.alt': 'Jira에 첨부 파일 추가',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.increased-storage.heading':
    'Standard에는 다음과 같은 고급 기능이 포함됩니다.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.increased-storage.title': '저장 공간 한도 늘리기',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.anonymous-access.description':
    '팀 외부의 사용자에게 안전한 액세스를 제공하세요.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.anonymous-access.title':
    '익명 액세스',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.heading':
    'Standard에는 다음과 같은 고급 기능이 포함됩니다.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.support.description':
    'Atlassian 전문가 팀의 지원을 받습니다.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.support.title':
    '업무 시간 지원',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.title': 'Standard 플랜 기능',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.user-roles.description':
    '다른 프로젝트 및 작업에 액세스할 수 있는 사용자를 더 효과적으로 제어하세요.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.user-roles.title':
    '사용자 역할 및 권한',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.storage-limits.description':
    '파일 첨부를 계속하려면 {standardStorageLimit}GB 스토리지로 업그레이드하세요',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.storage-limits.title':
    '{storageUsed}/{storageLimit}GB의 스토리지를 사용했습니다',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.storage-limits.title.aria':
    '{storageUsed}/{storageLimit}GB의 스토리지를 사용했습니다',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.unlimited-users.alt': 'Jira에 사용자 추가',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.unlimited-users.heading':
    'Standard에는 다음과 같은 고급 기능이 포함됩니다.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.unlimited-users.title': '무제한 사용자',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.user-limits.description':
    '{licensedUserLimit, plural, other {무제한 사용자를 이용하려면 업그레이드하세요. {licensedUserLimit}명이 넘는 사용자를 추가하면 자동으로 업그레이드됩니다.}}',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.user-limits.title':
    '{licensedUserLimit, plural, other {{numberOfUsers}/{licensedUserLimit}명의 사용자를 초대했습니다}}',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.continue': '한도 계속 유지',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.description':
    'Free 플랜을 이용하고 있습니다. Standard의 14일 무료 평가판을 사용하여 무제한 사용자, 추가 스토리지 등을 사용하세요. 언제든지 취소할 수 있습니다.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.title': 'Standard 플랜으로 업그레이드',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.try-now': '지금 사용해 보기',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.increased-storage.alt':
    'Jira Product Discovery에 첨부 파일 추가',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.increased-storage.heading':
    'Standard에는 다음과 같은 고급 기능이 포함됩니다.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.increased-storage.title': '저장 공간 한도 늘리기',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.custom-roles.description':
    '특정 권한을 가진 사용자 지정 프로젝트 역할을 만들어 더 세부적으로 관리하세요.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.custom-roles.title':
    '사용자 지정 프로젝트 역할',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.data-residency.description':
    '데이터를 호스팅할 위치를 선택합니다.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.data-residency.title':
    '데이터 보존',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.heading':
    'Standard에는 다음과 같은 고급 기능이 포함됩니다.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.support.description':
    'Atlassian 전문가 팀의 지원을 받습니다.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.support.title': '업무 시간 지원',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.title': 'Standard 기능',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.storage-limits.description':
    '파일 첨부를 계속하려면 {standardStorageLimit}GB 스토리지로 업그레이드하세요',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.storage-limits.title':
    '{storageUsed}/{storageLimit}GB의 스토리지를 사용했습니다',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.storage-limits.title.aria':
    '{storageUsed}/{storageLimit}GB의 스토리지를 사용했습니다',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.unlimited-creators.alt':
    'Jira Product Discovery에 작성자 추가',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.unlimited-creators.heading':
    'Standard에는 다음과 같은 고급 기능이 포함됩니다.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.unlimited-creators.title': '무제한 작성자',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.user-limits.description':
    '{licensedUserLimit, plural, other {무제한 작성자가 필요한 경우 업그레이드하세요. {licensedUserLimit}명의 작성자를 더 추가하면 자동으로 업그레이드됩니다.}}',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.user-limits.title':
    '{licensedUserLimit, plural, other {{numberOfUsers}/{licensedUserLimit}명의 작성자를 초대했습니다}}',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.continue': '한도 계속 유지',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.description':
    'Free 플랜을 이용하고 있습니다. 14일 무료 Standard 평가판을 시작하여 무제한 작성자, 추가 저장 공간 등을 이용하세요.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.title': 'Standard 플랜으로 업그레이드',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.try-now': '지금 사용해 보기',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.agent-limits-description':
    '무제한 에이전트를 위해 업그레이드하세요.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.agent-limits-popup-button': '에이전트란 무엇입니까?',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.agent-limits-popup-description':
    '에이전트는 Jira Service Management에서 고객 요청을 처리합니다. 고객 요청은 모든 사용자가 보낼 수 있습니다. Jira Service Management에서 요청을 제출할 수 있는 사용자 수에는 제한이 없습니다.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.agent-limits-popup-heading':
    'Jira Service Management에서 에이전트는 어떤 역할을 합니까?',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.agent-limits-popup-link': '에이전트에 대해 자세히 알아보기',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.agent-limits-title':
    '{licensedUserLimit, plural, other {{numberOfUsers}/{licensedUserLimit}명의 에이전트를 초대했습니다}}',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.increased-storage.alt': '첨부 파일 추가 중',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.increased-storage.heading':
    'Standard에는 다음과 같은 고급 기능이 포함됩니다.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.increased-storage.title': '저장 공간 한도 늘리기',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.heading':
    'Standard에는 다음과 같은 고급 기능이 포함됩니다.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.on-call-management.description':
    '사용자 지정 회람 규칙 및 에스컬레이션 정책을 만듭니다.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.on-call-management.title':
    '대기 중 담당자 관리',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.support.description':
    'Atlassian 전문가 팀의 지원을 받습니다.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.support.title': '업무 시간 지원',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.title': 'Standard 기능',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.unlimited-email-notifications.description':
    '요청 시 활동에 대해 모두에게 업데이트합니다.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.unlimited-email-notifications.title':
    '무제한 이메일 알림',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.storage-limits.description':
    '파일 첨부를 계속하려면 {standardStorageLimit}GB 스토리지로 업그레이드하세요',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.storage-limits.title':
    '{storageUsed}/{storageLimit}GB의 스토리지를 사용했습니다',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.storage-limits.title.aria':
    '{storageUsed}/{storageLimit}GB의 스토리지를 사용했습니다',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.unlimited-creators.alt': '에이전트 추가',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.unlimited-creators.heading':
    'Standard에는 다음과 같은 고급 기능이 포함됩니다.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.unlimited-creators.title': '무제한 에이전트',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.continue': '한도 계속 유지',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.description':
    'Free 플랜을 이용하고 있습니다. Standard의 14일 무료 평가판을 통해 에이전트 무제한, 추가 스토리지 등을 사용하세요.',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.heading': 'Standard 플랜으로 업그레이드',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.try-now': '지금 사용해 보기',
  '@atlassian/edition-awareness.dialog.payment-details-popup.jsw.add-payment-details-button': '결제 세부 정보 추가',
  '@atlassian/edition-awareness.dialog.payment-details-popup.jsw.premium-content':
    '평가판 기간 이후에도 Premium 플랜을 계속 이용하려면 결제 세부 정보를 추가하세요.',
  '@atlassian/edition-awareness.dialog.payment-details-popup.jsw.premium-heading': 'Premium 평가판',
  '@atlassian/edition-awareness.dialog.payment-details-popup.jsw.standard-content':
    '평가판 기간 이후에도 Standard 플랜을 계속 이용하려면 결제 세부 정보를 추가하세요.',
  '@atlassian/edition-awareness.dialog.payment-details-popup.jsw.standard-heading': 'Standard 평가판',
  '@atlassian/edition-awareness.dialog.premium-add-payment.add-payment': '결제 세부 정보 추가',
  '@atlassian/edition-awareness.dialog.premium-add-payment.carousel.premium-features.ai.description':
    'AI 기반 ITSM 기능으로 뛰어난 서비스 경험을 제공하세요.',
  '@atlassian/edition-awareness.dialog.premium-add-payment.carousel.premium-features.ai.title':
    'Atlassian Intelligence(AI)',
  '@atlassian/edition-awareness.dialog.premium-add-payment.carousel.premium-features.automation.description':
    '주요 인시던트 만들기 프로세스를 자동화합니다.',
  '@atlassian/edition-awareness.dialog.premium-add-payment.carousel.premium-features.automation.title':
    '고급 인시던트 관리',
  '@atlassian/edition-awareness.dialog.premium-add-payment.carousel.premium-features.support.description':
    'Atlassian 전문가 팀의 연중무휴 지원을 받으세요.',
  '@atlassian/edition-awareness.dialog.premium-add-payment.carousel.premium-features.support.title': 'Premium 지원',
  '@atlassian/edition-awareness.dialog.premium-add-payment.carousel.premium-features.title':
    'Premium에는 다음과 같은 고급 기능이 포함됩니다.',
  '@atlassian/edition-awareness.dialog.premium-add-payment.continue': '지금은 계속 이용',
  '@atlassian/edition-awareness.dialog.premium-add-payment.subtitle':
    'Premium 기능을 유지하고 평가판 종료 전에 취소되지 않도록 하려면 결제 세부 정보를 추가하세요.',
  '@atlassian/edition-awareness.dialog.premium-add-payment.title':
    '{trialDaysLeft, plural, other {Premium 평가판이 {trialDaysLeft,number}일 후에 종료됩니다}}',
  '@atlassian/edition-awareness.dialog.reverse-trial-popup.jsw.add-payment-details-link':
    '결제 세부 정보를 추가하여 Premium를 계속 이용하세요',
  '@atlassian/edition-awareness.dialog.reverse-trial-popup.jsw.after-trial':
    '평가판이 종료된 후에는 Free로 다운그레이드됩니다.',
  '@atlassian/edition-awareness.dialog.reverse-trial-popup.jsw.end-trial-and-change-plans-link':
    '평가판 종료 및 플랜 변경',
  '@atlassian/edition-awareness.dialog.reverse-trial-popup.jsw.explore-premium-features-link': 'Premium 기능 살펴보기',
  '@atlassian/edition-awareness.dialog.reverse-trial-popup.jsw.heading': '30일 Premium 평가판',
  '@atlassian/edition-awareness.dialog.standard-add-payment.add-payment': '결제 세부 정보 추가',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.content-insights.alt':
    'Confluence의 페이지 인사이트 화면',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.content-insights.title':
    '콘텐츠 인사이트',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.content-restrictions.alt':
    'Confluence의 페이지 제한 화면',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.content-restrictions.title':
    '콘텐츠 제한',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.guest-access.alt':
    'Confluence의 게스트 액세스 화면',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.guest-access.title': '게스트 액세스',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.unlimited-users.alt':
    'Confluence 인스턴스에 사용자 추가',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.unlimited-users.title': '무제한 사용자',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.add-payment':
    'Standard 플랜을 유지하려면 결제 세부 정보를 추가하세요.',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.alt': '첨부 파일 추가 중',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.exceeded-free':
    'Free 플랜의 {freeStorageLimit}GB 스토리지 한도를 초과했습니다.',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.heading':
    '높은 스토리지 한도를 유지하려면 Standard를 계속 이용하세요',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.standard-includes.heading':
    'Standard에는 다음과 같은 고급 기능이 포함됩니다.',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.standards-limit':
    'Standard 플랜에는 {storageLimit}GB의 스토리지 한도가 있습니다.',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.title': '저장 공간 한도 늘리기',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.usage':
    '<strong>{storageUsed}GB</strong>의 스토리지를 사용했습니다',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.custom-roles.description':
    '사용자 지정 회람 규칙 및 에스컬레이션 정책을 만드세요.',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.email-notifications.description':
    '요청 시 활동에 대해 모두에게 업데이트합니다.',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.email-notifications.title':
    '무제한 이메일 알림',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.heading':
    'Standard에는 다음과 같은 고급 기능이 포함됩니다.',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.on-call-management.title':
    '대기 중 담당자 관리',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.support.description':
    'Atlassian 전문가 팀의 지원을 받습니다.',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.support.title': '업무 시간 지원',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.title': 'Standard 기능',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.storage-limit-bar.aria':
    '{storageUsed}/{storageLimit}GB 사용함',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-creators.jpd.heading':
    '{userCount, plural, other {<span>{userCount,number}명의 작성자</span>를 초대했습니다. Free 플랜은 작성자가 3명으로 제한됩니다.}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users-image.alt': '사용자 추가 중',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users-image.heading':
    'Standard에는 다음과 같은 고급 기능이 포함됩니다.',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users-image.title':
    '{product, select, jpd {무제한 작성자} jsm {무제한 에이전트} jira {무제한 사용자} confluence {무제한 사용자} other {무제한 사용자}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users.heading':
    '{product, select, jpd {Standard를 계속 사용하여 무제한 작성자를 그대로 이용} jsm {Standard를 계속 사용하여 에이전트 수를 무제한으로 유지} jira {Standard를 계속 사용하여 무제한 사용자를 그대로 이용} confluence {Standard를 계속 사용하여 무제한 사용자를 그대로 이용} other {Standard를 계속 사용하여 무제한 사용자를 그대로 이용}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users.jsm-popup':
    '에이전트는 Jira Service Management에서 고객 요청을 처리합니다. 고객 요청은 모든 사용자가 보낼 수 있습니다. Jira Service Management에서 요청을 제출할 수 있는 사용자 수에는 제한이 없습니다.',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users.jsm-popup-link':
    '에이전트에 대해 자세히 알아보기',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users.jsm-popup-what-are-agents':
    'Jira Service Management에서 에이전트는 어떤 역할을 합니까?',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users.jsm.heading':
    '{userCount, plural, other {<span>{userCount,number}명의 에이전트</span>를 초대했습니다. Free 플랜은 에이전트가 3명으로 제한됩니다. <link>에이전트란 무엇인가요?</link>}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users.title':
    '{product, select, jpd {무제한 작성자} jsm {무제한 에이전트} jira {무제한 사용자} confluence {무제한 사용자} other {무제한 사용자}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.continue': '지금은 계속 이용',
  '@atlassian/edition-awareness.dialog.standard-add-payment.jpd.carousel.standard-features.custom-roles.description':
    '특정 권한을 가진 사용자 지정 프로젝트 역할을 만들어 더 세부적으로 관리하세요.',
  '@atlassian/edition-awareness.dialog.standard-add-payment.jpd.carousel.standard-features.custom-roles.title':
    '사용자 지정 프로젝트 역할',
  '@atlassian/edition-awareness.dialog.standard-add-payment.jpd.carousel.standard-features.data-residency.description':
    '데이터를 호스팅할 위치를 선택합니다.',
  '@atlassian/edition-awareness.dialog.standard-add-payment.jpd.carousel.standard-features.data-residency.title':
    '데이터 보존',
  '@atlassian/edition-awareness.dialog.standard-add-payment.jpd.carousel.standard-features.support.description':
    'Atlassian 전문가 팀의 지원을 받습니다.',
  '@atlassian/edition-awareness.dialog.standard-add-payment.jpd.carousel.standard-features.support.title':
    '업무 시간 지원',
  '@atlassian/edition-awareness.dialog.standard-add-payment.limits-content.storage-limits.description':
    'Free 플랜 한도에서 {dataUsageOverFreeLimitInGB}GB를 초과했습니다',
  '@atlassian/edition-awareness.dialog.standard-add-payment.limits-content.storage-limits.title':
    '{storageUsed}/{storageLimit}GB 사용',
  '@atlassian/edition-awareness.dialog.standard-add-payment.limits-content.storage-limits.title.aria':
    '{storageUsed}/{storageLimit}GB의 스토리지를 사용했습니다',
  '@atlassian/edition-awareness.dialog.standard-add-payment.limits-content.user-limits.description':
    '팀 동료 및 이해 관계자를 초대하여 공동 작업하세요',
  '@atlassian/edition-awareness.dialog.standard-add-payment.limits-content.user-limits.description.near-limit':
    '{userLimitOverFreeLimit, plural, other {팀이 Free 플랜 한도에서 {userLimitOverFreeLimit}명을 초과했습니다}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.limits-content.user-limits.title':
    '무제한 사용자를 활용하세요',
  '@atlassian/edition-awareness.dialog.standard-add-payment.limits-content.user-limits.title.near-limit':
    '무제한 사용자의 이점을 활용하고 있습니다',
  '@atlassian/edition-awareness.dialog.standard-add-payment.subtitle':
    'Standard 기능을 유지하고 평가판 종료 전에 취소되지 않도록 하려면 결제 세부 정보를 추가하세요.',
  '@atlassian/edition-awareness.dialog.standard-add-payment.subtitle-trial-days-left':
    '{trialDaysLeft, plural, other {평가판이 종료된 후에 Standard 기능을 유지하려면 결제 세부 정보를 추가하세요. 평가판이 {trialDaysLeft}일 후에 종료됩니다.}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.title':
    '{trialDaysLeft, plural, other {Standard 평가판이 {trialDaysLeft,number}일 후에 종료됩니다}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.title-take-action': '평가판에서 조치를 취하세요',
  '@atlassian/edition-awareness.dialog.standard-to-premium.compare-features.cta': '플랜 및 가격 비교',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.24-7-support.jira.text': '연중무휴 지원',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.24-7-support.jira.tooltip':
    '필요할 때 Atlassian의 전문가가 제공하는 지원을 받아보세요',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.24-7-support.name': '연중무휴 지원',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.24-7-support.text': '연중무휴 지원',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.24-7-support.tooltip':
    '필요할 때 언제든지 Atlassian의 지원을 받으세요',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.24-7-support.value':
    '필요할 때 언제든지 Atlassian의 지원을 받으세요',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.admin-insights.jira.text': '관리자 인사이트',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.admin-insights.jira.tooltip':
    '사용자 활동, 제품 사용 및 보안을 추적하세요',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.admin-insights.name': '관리자 인사이트',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.admin-insights.text': '관리자 인사이트',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.admin-insights.tooltip':
    '사용자 활동, 제품 사용 및 보안을 추적하세요',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.admin-insights.value':
    '사용자 활동, 제품 사용 및 보안을 추적하세요',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.advanced-alerts.text': '고급 알림',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.advanced-alerts.tooltip':
    '인시던트를 더 빨리 해결하는 데 도움이 되는 알림을 받으세요',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.ai.text': 'Atlassian Intelligence',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.ai.tooltip':
    '페이지를 요약, 글 작성 도움 및 이외의 기능',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.analytics.name': '분석',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.analytics.text': '분석',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.analytics.tooltip':
    '사용자가 페이지에 참여하는 방식에 대한 데이터 확보',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.analytics.value':
    '사용자가 페이지에 참여하는 방식에 대한 데이터 확보',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.asset-management.name': '자산 관리',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.asset-management.text': '자산 관리',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.asset-management.tooltip':
    '회사 재고 보관, 매핑 및 감사',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.asset-management.value':
    '회사 인벤토리 보관, 매핑 및 감사',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.atlassian-intelligence.name':
    'Atlassian Intelligence',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.atlassian-intelligence.text':
    'Atlassian Intelligence',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.atlassian-intelligence.tooltip':
    'AI를 사용하여 위험 발견, 작업 자동화 및 편집',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.atlassian-intelligence.value':
    'AI를 사용하여 위험 발견, 작업 자동화 및 편집',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.company-hub.text': '회사 허브',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.company-hub.tooltip':
    '모든 회사 정보를 확인할 수 있는 단일 정보 출처를 구축하세요',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.cross-team-planning.name': '교차 팀 계획',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.cross-team-planning.text': '교차 팀 계획',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.cross-team-planning.tooltip':
    '모든 프로젝트 및 타임라인을 한곳에서 확인하세요',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.cross-team-planning.value':
    '모든 프로젝트 및 타임라인을 한곳에서 확인하세요',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.deployment-gating.text': '배포 제어',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.deployment-gating.tooltip':
    '자동화된 컨트롤을 통해 위험한 변경을 방지하세요',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.incident-management.text': '인시던트 관리',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.incident-management.tooltip':
    '문제를 식별하고 이슈를 추적하고 에스컬레이션하세요',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.mission-control.name': '미션 컨트롤',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.mission-control.text': '미션 컨트롤',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.mission-control.tooltip':
    '한곳에서 권한 관리 및 인사이트 얻기',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.mission-control.value':
    '한곳에서 권한 관리 및 인사이트 얻기',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.project-archiving.text': '프로젝트 보관',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.project-archiving.tooltip':
    '비활성 상태의 업무를 보관하여 업무를 체계화하세요',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.real-time-incident-monitoring.text':
    '실시간 인시던트 모니터링',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.real-time-incident-monitoring.tooltip':
    '인시던트 발생 시 인시던트를 추적 및 관리하세요',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.release-tracks.text': '릴리스 트랙',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.release-tracks.tooltip':
    '변경 사항을 릴리스하는 시점 및 방법 제어',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.sandbox.text': '샌드박스',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.sandbox.tooltip':
    '프로덕션에 들어가기 전에 안전하게 테스트하고 실험하세요',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.team-calendar.name': '팀 캘린더',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.team-calendar.text': '팀 캘린더',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.team-calendar.tooltip':
    '팀 전반의 마감 날짜 및 휴무 계획',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.team-calendar.value':
    '팀 전반의 마감 날짜 및 휴무 계획',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.virtual-service-agents.name': '가상 서비스 에이전트',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.virtual-service-agents.text': '가상 서비스 에이전트',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.virtual-service-agents.tooltip':
    'Atlassian Intelligence 기반 에이전트를 사용하여 일반적인 이슈를 처리하세요',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.virtual-service-agents.value':
    'AI 기반 에이전트를 사용하여 일반적인 문제를 처리하세요.',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.whiteboards.text': '무제한 화이트보드',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.whiteboards.tooltip':
    '무한 캔버스에서 브레인스토밍 또는 흐름 만들기',
  '@atlassian/edition-awareness.dialog.standard-to-premium.heading':
    '더 많은 기능을 원하십니까? Premium을 사용해 보세요',
  '@atlassian/edition-awareness.dialog.standard-to-premium.highlighted-features.header.text':
    '이 기능을 무료로 사용해 보세요',
  '@atlassian/edition-awareness.dialog.standard-to-premium.highlighted-features.premium-label.text': 'Premium',
  '@atlassian/edition-awareness.dialog.standard-to-premium.subtitle':
    '30일 무료 평가판을 시작하여 Premium의 주요 기능을 이용해 보세요. 평가판이 종료되기 3일 전에 알려 드리겠습니다. 언제든지 취소할 수 있습니다.',
  '@atlassian/edition-awareness.dialog.standard-to-premium.try-now.cta': '계속',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.add-payment-details': '결제 세부 정보 추가',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.heading': '무료 한도를 초과했습니다',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.maybe-later': '나중에',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.storage-limits-info.base-limit.title':
    'Free 한도({freeStorageLimit}GB)',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.storage-limits-info.confluence.description':
    'Free 플랜에서는 새 페이지를 추가할 수 없습니다.',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.storage-limits-info.jira.description':
    'Free 플랜에서는 한도를 초과하면 새 파일을 추가할 수 없습니다.',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.storage-limits-info.title':
    '{storageUsed}GB의 저장 공간 사용됨',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.subtitle.default':
    '다운그레이드하거나 비활성화되지 않게 하려면 지금 결제를 추가하세요. 평가판이 종료될 때까지는 요금이 청구되지 않습니다.',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.subtitle.inPredunning.storageLimitBreaker':
    '다운그레이드되지 않게 하려면 결제를 추가하세요.',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.subtitle.inPredunning.userLimitBreaker':
    '비활성화되지 않게 하려면 결제를 추가하세요.',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.subtitle.storageLimitBreakerForConfluence':
    '스페이스 및 페이지를 계속 만들려면 지금 결제를 추가하세요. 평가판이 종료될 때({trialEndDate})까지는 요금이 청구되지 않습니다.',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.subtitle.storageLimitBreakerForJira':
    '파일 및 이미지를 계속 업로드하려면 지금 결제를 추가하세요. 평가판이 종료될 때({trialEndDate})까지는 요금이 청구되지 않습니다.',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.subtitle.userAndStorageLimitBreaker':
    '다운그레이드하거나 비활성화되지 않게 하려면 지금 결제를 추가하세요. 평가판이 종료될 때({trialEndDate})까지는 요금이 청구되지 않습니다.',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.subtitle.userLimitBreaker':
    '비활성화되지 않게 하려면 결제를 추가하세요. 평가판이 종료될 때({trialEndDate})까지는 요금이 청구되지 않습니다.',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.user-limits-info.description.over-limit':
    '{userLimit, plural, other {Free에서는 {userLimit}명의 사용자까지만 포함할 수 있습니다.}}',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.user-limits-info.description.under-limit':
    '팀 동료 및 이해 관계자를 초대하여 공동 작업하세요',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.user-limits-info.divider-limit-label':
    '무료 한도({userLimit}명)',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.user-limits-info.title.over-limit':
    '{licensedUsers, plural, other {{licensedUsers}명 초대됨}}',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.user-limits-info.title.under-limit':
    '무제한 사용자를 활용하세요',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.breached-limits.subtitle':
    '업그레이드할 때까지는 첨부 파일을 추가할 수 없습니다',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.breached-limits.title': '스토리지 한도 초과',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.description-for-jira-admin':
    '업그레이드하여 더 많은 스토리지를 사용하거나 <Link>첨부 파일을 삭제</Link>하세요.',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.description-for-non-admin':
    '관리자에게 문의하여 더 많은 스토리지를 확보하도록 업그레이드하세요.',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.dismiss': '해제',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.feature.more-files':
    '문서, 파일 및 이미지를 제한 없이 업로드',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.feature.more-storage':
    'Standard를 통해 125배 더 많은 팀 저장 공간 사용',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.feature.more-users':
    '무제한 사용자, 추가 보안 등을 활용하세요',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.free-limit': 'Free 한도',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.free-limit-value': '2GB',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.standard-limit': 'Standard 한도',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.standard-limit-value': '250GB',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.title':
    '팀에서 무료 저장 공간을 모두 사용했습니다. 업그레이드하여 더 많은 저장 공간을 사용하세요',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.upgrade': '업그레이드',
  '@atlassian/edition-awareness.dialog.timeline.trial-begins.premium.description':
    'Premium의 강력한 기능을 살펴보세요.',
  '@atlassian/edition-awareness.dialog.timeline.trial-begins.premium.title': 'Premium 평가판 시작',
  '@atlassian/edition-awareness.dialog.timeline.trial-begins.standard.description':
    'Standard의 강력한 기능을 살펴보세요.',
  '@atlassian/edition-awareness.dialog.timeline.trial-begins.standard.title': 'Standard 평가판 시작',
  '@atlassian/edition-awareness.dialog.timeline.trial-current-day.premium.description':
    'Premium이 팀에 적합한지 결정하세요.',
  '@atlassian/edition-awareness.dialog.timeline.trial-current-day.standard.description':
    'Standard가 팀에 적합한지 결정하세요.',
  '@atlassian/edition-awareness.dialog.timeline.trial-current-day.title':
    '{trialDaysLeft, plural, other {오늘: {trialDaysLeft,number}일 후에 평가판 종료}}',
  '@atlassian/edition-awareness.dialog.timeline.trial-ends.premium.description':
    '이 날짜까지 조치를 취해 Premium을 유지하거나 Free로 다운그레이드하세요.',
  '@atlassian/edition-awareness.dialog.timeline.trial-ends.standard.description':
    '이 날짜까지 조치를 취해 Standard를 계속 사용하거나 Free로 다운그레이드하세요.',
  '@atlassian/edition-awareness.dialog.timeline.trial-ends.title': '평가판 종료',
  '@atlassian/edition-awareness.edition-awareness-dismiss-button.data-privacy.link':
    'Atlassian의 데이터 개인 정보 보호에 대해 자세히 알아보기',
  '@atlassian/edition-awareness.edition-awareness-dismiss-button.reason-1': '팀의 규모',
  '@atlassian/edition-awareness.edition-awareness-dismiss-button.reason-2': '기존 Atlassian 제품',
  '@atlassian/edition-awareness.edition-awareness-dismiss-button.why-am-i-seeing-this':
    '{offering}(으)로 팀의 생산성을 개선할 것이라고 생각합니다. 다음을 기반으로 청구 관리자에게만 표시되는 추천입니다.',
  '@atlassian/edition-awareness.link.add-payment-tooltip': '구독을 유지하려면 결제 세부 정보를 추가하세요',
  '@atlassian/edition-awareness.link.jira-standard-trial-overview-tooltip': '평가판 및 결제 방법에 대한 자세한 내용',
  '@atlassian/edition-awareness.spotlight.message':
    '업그레이드할 준비가 되지 않았습니까? 준비가 되면 프로필로 돌아오세요.',
  'trial-components.action.menu.downgrade.message.v2': '평가판이 종료된 후에는 Free로 다운그레이드됩니다.',
  'trial-components.add.payment.premium.button': '결제 세부 정보를 추가하여 Premium를 계속 이용하세요',
  'trial-components.end.trial.button': '평가판 종료 및 플랜 변경',
  'trial-components.explore.premium.button': 'Premium 기능 살펴보기',
  'trial-components.premium.charge-message': '{trialEndDate} 평가판 종료 시 월간 Premium 요금이 청구됩니다.',
  'trial-components.premium.feature-highlight-description.toggle': '레이블을 통해 Premium 기능을 파악할 수 있습니다.',
  'trial-components.premium.feature-highlight-title.toggle': 'Premium 기능 강조 표시',
  'trial-components.premium.review-feature-guide.button': '기능 가이드 검토',
  'trial-components.premium.trial.title': 'Premium 평가판',
  'trial-components.see.billing.button': '청구 세부 정보 보기',
};
